import { SortOrder } from '@duke-hq/lib/pagination';
import type { SortColumnInputSchema } from '@duke-hq/ui/components/DataTable/schema';

export type SortableSeedRow = {
  name: string;
  lastRunAt: Date | null;
  status: string;
};

const comparators = new Map<string, (a: SortableSeedRow, b: SortableSeedRow) => number>([
  ['name', (a, b) => a.name.localeCompare(b.name)],
  ['lastRunAt', (a, b) => (a.lastRunAt?.getTime() ?? 0) - (b.lastRunAt?.getTime() ?? 0)],
  ['status', (a, b) => a.status.localeCompare(b.status)],
]);

export function sortSeedRows<Row extends SortableSeedRow>(
  rows: Row[],
  sortOrder: SortColumnInputSchema,
): Row[] {
  const activeSorts = Object.entries(sortOrder).flatMap(([column, direction]) => {
    const compare = comparators.get(column);
    return compare === undefined ? [] : [{ compare, direction }];
  });

  if (activeSorts.length === 0) {
    return rows;
  }

  return [...rows].sort((a, b) => {
    for (const { compare, direction } of activeSorts) {
      const result = compare(a, b);
      if (result !== 0) {
        return direction === SortOrder.ASC ? result : -result;
      }
    }
    return 0;
  });
}
